<div class="modal-header justify-content-center">
    <h4 class="modal-title text-center">{{ modalData?.title }}</h4>
</div>
<div class="modal-body mt-3">
    <div [formGroup]="roleForm">
        <label  for="reason" class="form-label d-block text-start">
            Please provide a reason:
        </label>

        <div class="mb-3">
            <ng-select placeholder="Select Reason" formControlName="deactivationReasonId"
                [items]="deactivationReasonList" bindLabel="value" bindValue="id" [searchable]="true"
                [clearable]="true">
            </ng-select>

            <div *ngIf="
          submitted &&
          roleForm.get('deactivationReasonId')?.hasError('required')
        " class="text-danger">
                Reason is required.
            </div>
        </div>

        <div class="mb-3" *ngIf="showOtherReason">
            <label  for="reason"class="form-label" > Other Reason <span class="text-danger">*</span> </label>

            <input id="reason" type="text" class="form-control" placeholder="Enter Other Reason"
                formControlName="otherDeactivationReason" />
                 <div *ngIf="submitted && roleForm.controls['otherDeactivationReason'].hasError('required')" class="text-danger error">
              Other Reason is Required.
            </div>
            <div *ngIf="roleForm.controls['otherDeactivationReason'].hasError('pattern') && submitted" class="text-danger error">
              Other Reason can only contain letters, numbers.
            </div>
            <div *ngIf="roleForm.controls['otherDeactivationReason'].hasError('maxlength')" class="text-danger error">
              Other Reason cannot exceed 100 characters.
            </div>
            <div *ngIf="roleForm.get('otherDeactivationReason').hasError('duplicateRole') && roleForm.get('otherDeactivationReason')?.touched"
              class="text-danger error">
              This Other Reason already exists in the list. Please enter a different reason.
            </div>
        </div>
    </div>
</div>
<div class="modal-footer bg-transparent border-0 pb-4 pt-0 justify-content-center">
    <button type="button" class="btn rounded btn-action" [ngClass]="
      modalData?.classConfirmButton
        ? modalData?.classConfirmButton
        : 'btn-danger'
    " (click)="onSubmit()" [disabled]="roleForm.pristine">
       Deactivate
    </button>
    <div class="ml-auto">
       
        <button type="button" class="btn btn-cancel" (click)="closeModal()" >
           CANCEL
        </button>
    </div>
</div>